import { useRef } from 'react';

export default function useScrollerRef() {
  const scroller = useRef<HTMLElement>();

  const setScrollerRef = (scrollerRef: HTMLElement | null) => {
    scroller.current = scrollerRef ?? undefined;
  };

  return { scroller: scroller.current, setScrollerRef };
}
